import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import {
  LIST_TABLE_SCROLL_HEIGHT,
  ScrollableView,
} from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";

import AddSupplierModal from "./components/suppliersModal";
import SupplierTable from "./components/SupplierTable";
import { selectData, selectLoading } from "./redux/selector";
import { SuppliersSaga } from "./redux/saga";
import { actions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";
export const Suppliers = () => {

  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const rows = useSelector(selectData)
  const loading = useSelector(selectLoading)
  const dispatch = useDispatch()
  
  useInjectReducer({
    key: sliceKey,
    reducer,
  });
  
  useInjectSaga({
    key: sliceKey,
    saga: SuppliersSaga
  })
  
  useEffect(() => {
    dispatch(actions.getSupplierList());
  }, [dispatch]);
  

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.SUPPLIERS")} iconPosition="end" />
          <Box dir="ltr">
            <AddButton
              label={t("SUPPLIERS.ADD")}
              onClick={() => dispatch(actions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height={LIST_TABLE_SCROLL_HEIGHT}
              loadMore={() => undefined}
              hasMoreItems={false}
            >
              <SupplierTable
                rows={rows}
                loading={loading && rows.length === 0}
              />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddSupplierModal />
    </Box>
  )
}

export default Suppliers
